export default __webpack_public_path__ + "static/media/peep-24.e2ccf2f0.svg";